import { ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { EventTableConfig, EventTableConfigModalContent } from '@/components/eventComponent/';
import { StyledModal } from '@/styles';
import { ModalControllerType } from '@/types.ts';

type EventTableConfigModalProps = {
  defaultTableConfig: EventTableConfig;
  widgetId: string;
  modalController: ModalControllerType;
};

export const EventTableConfigModal = ({
  defaultTableConfig,
  widgetId,
  modalController: { open, onClose },
}: EventTableConfigModalProps) => {
  const { t } = useTranslation(['common', 'eventStream']);
  return (
    <>
      <StyledModal open={open} onClose={onClose}>
        <ModalHeader title={t('eventStream:eventTableConfiguration')} onClose={onClose} />
        <EventTableConfigModalContent
          defaultTableConfig={defaultTableConfig}
          widgetId={widgetId}
          onClose={onClose}
          onSave={onClose}
        />
      </StyledModal>
    </>
  );
};
